import {Network} from "./Network"

export class LeaderBoardService {
    static getLeaderBoard () {
        return Network.fetch(true, '/leadboard')
    }
}
